<div class="dialog-container">
    <button mat-icon-button class="close-button" (click)="onCancel()">
        <span class="material-symbols-outlined">close</span>
    </button>
    <div class="dialog-header">
        <h2 mat-dialog-title>Please Add Document Description</h2>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSave()">
        <mat-dialog-content>
            <mat-form-field>
                <textarea matInput formControlName="note" placeholder="Enter Document Description" cdkTextareaAutosize cdkAutosizeMinRows="8" cdkAutosizeMaxRows="10"></textarea>
            </mat-form-field>
        </mat-dialog-content>

        @if (formControls.note?.errors) {
            @if (formControls.note?.errors?.maxlength) {
                <mat-error>Character limit: {{formControls.note?.errors?.maxlength.requiredLength}} (Current: {{formControls.note?.errors?.maxlength.actualLength}})</mat-error>
            }
        }

        @if (!data.wasSubmitted) {
            <mat-dialog-actions>
                <button mat-raised-button type="submit" color="primary">
                    Add Note
                </button>
            </mat-dialog-actions>
        }
    </form>
</div>